export default __webpack_public_path__ + "static/topology-a511786bdc3928ab0db94f03056500af.svg";